import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { PhasrMonitoredRulesGridDataProviderFactory } from '../factory/PhasrMonitoredRulesGridDataProviderFactory';
import { PhasrMonitoredRulesGridBaseDataProvider } from '../dataProvider/PhasrMonitoredRulesGridBaseDataProvider';
import { BehaviorProfilesOutput } from '../../../phasrRecommendations/phasrRestrictedProfilesSelector/types';

export class PhasrMonitoredRulesGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrMonitoredRulesGridDataProviderFactory;
  public dataProvider: PhasrMonitoredRulesGridBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrMonitoredRulesGridDataProviderFactory(),
    });
  }

  public async updateUserBehaviouralProfiles(objectId: string, ruleId: number, companyId: string,  changes: BehaviorProfilesOutput | null = null): Promise<{success: boolean, code?: number}> {
    return await this.dataProvider.updateUserBehaviouralProfiles(objectId, ruleId, companyId, changes);
  }
}
